module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "homeView"
    }
  }, [_c('div', {
    staticClass: "search-wrapper"
  }, [_c('div', {
    staticClass: "search-head"
  }, [_c('div', {
    staticClass: "prev-btn",
    on: {
      "click": function($event) {
        _vm.prev()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    staticClass: "search-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchVal),
      expression: "searchVal"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "type": "input",
      "id": "your-input-id",
      "placeholder": "搜索音乐、歌手、专辑"
    },
    domProps: {
      "value": (_vm.searchVal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchVal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchVal),
      expression: "searchVal"
    }],
    staticClass: "input-clear closeIcon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.searchVal = ''
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    ref: "content",
    staticClass: "content",
    staticStyle: {
      "height": "100%",
      "overflow": "hidden"
    }
  }, [_c('scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.logController),
      expression: "!logController"
    }],
    attrs: {
      "data": _vm.songItems,
      "pullup": true
    },
    on: {
      "scrollToEnd": function($event) {
        _vm.songLoadMore()
      }
    }
  }, [_c('ul', {
    staticClass: "search-content"
  }, [(_vm.artist) ? _c('router-link', {
    staticClass: "artist-matching search-list",
    attrs: {
      "tag": "li",
      "to": {
        name: 'artist',
        params: {
          artist: _vm.artist
        }
      }
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.artist.avatar.small,
      "width": "48",
      "height": "48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nowrap"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("歌手：" + _vm._s(_vm.artist.name) + "(" + _vm._s(_vm.artist.country) + ")")])])]) : _vm._e(), _vm._v(" "), (_vm.album) ? _c('li', {
    staticClass: "artist-matching search-list"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.album.pic_small,
      "width": "48",
      "height": "48"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nowrap"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("专辑：" + _vm._s(_vm.album.title) + "(" + _vm._s(_vm.album.publishcompany) + ")")]), _vm._v(" "), _c('p', [_vm._v("发行时间：" + _vm._s(_vm.album.publishtime))])])]) : _vm._e(), _vm._v(" "), _c('songList', {
    attrs: {
      "styles": 2,
      "songs": _vm.songItems
    }
  }), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }]
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noMOre),
      expression: "noMOre"
    }],
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px",
      "font-size": "13px"
    }
  }, [_vm._v("没有更多数据")])], 1)]), _vm._v(" "), _c('scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logController),
      expression: "logController"
    }],
    ref: "logScroll"
  }, [_c('ul', {
    staticClass: "searchLog search-content"
  }, [_vm._l((_vm.searchLog), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "search-list",
      on: {
        "click": function($event) {
          _vm.searchVal = item
        }
      }
    }, [_vm._v("\n                            " + _vm._s(item) + "\n                            "), _c('span', {
      staticClass: "delete closeIcon",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.logDelete(item)
        }
      }
    }, [_vm._v("×")])])
  }), _vm._v(" "), (!_vm.searchLog.length) ? _c('li', {
    staticStyle: {
      "padding": "20px 0",
      "text-align": "center"
    }
  }, [_vm._v("没有搜索记录")]) : _vm._e()], 2)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2f693850"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/view/search/search.vue
// module id = 198
// module chunks = 1